import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_366",
		"data-name": "Group 366",
		transform: "translate(0 -0.034)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Ellipse_126",
			"data-name": "Ellipse 126",
			d: "M10,1.8A8.2,8.2,0,1,0,18.2,10,8.209,8.209,0,0,0,10,1.8M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
			transform: "translate(0 0.034)",
			fill: "current"
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_365",
			"data-name": "Group 365",
			transform: "translate(6.236 4.771)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_385",
				"data-name": "Path 385",
				d: "M3035.648,1763.795c0-.817-.7-1.371-1.823-1.371a2.752,2.752,0,0,0-2.378,1.123l-1.415-.918a4.639,4.639,0,0,1,3.953-1.781c2.145,0,3.574.977,3.574,2.655,0,2.378-2.495,2.6-2.495,4.319h-1.853C3033.212,1765.662,3035.648,1765.253,3035.648,1763.795Zm-2.669,6.375a1.16,1.16,0,1,1,1.166,1.138A1.128,1.128,0,0,1,3032.979,1770.169Z",
				transform: "translate(-3030.032 -1760.848)",
				fill: "current"
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgSupport);
export { ForwardRef as ReactComponent };
